// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1lsIg","ranges":"BmiRanges_ranges__1UN_R"};